import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization member, you can create and publish public and private packages within the organization's scope.`}</p>
    <h2>{`Creating an organization scoped package`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, make a directory with the name of the package you would like to create.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`mkdir /path/to/package/directory
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Navigate to the newly-created package directory.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To create an organization scoped package, on the command line, run:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm init --scope=<your_org_name>
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To verify the package is using your organization scope, in a text editor, open the package's `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file and check that the name is `}<inlineCode parentName="p">{`@your_org_name/<pkg_name>`}</inlineCode>{`, replacing `}<inlineCode parentName="p">{`your_org_name`}</inlineCode>{` with the name of your organization.`}</p>
      </li>
    </ol>
    <h2>{`Publishing a private organization scoped package`}</h2>
    <p>{`By default, `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` will publish a scoped package as private.`}</p>
    <p>{`By default, any scoped package is published as private. However, if you have an organization that does not have the Private Packages feature, `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` will fail unless you pass the `}<inlineCode parentName="p">{`access`}</inlineCode>{` flag.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, navigate to the package directory.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{`.`}</p>
      </li>
    </ol>
    <p>{`Private packages will say `}<inlineCode parentName="p">{`private`}</inlineCode>{` below the package name on the npm website.`}</p>
    <>{shared['organization-package-private'].image}</>
    <h2>{`Publishing a public organization scoped package`}</h2>
    <p>{`To publish an organization scoped package as public, use `}<inlineCode parentName="p">{`npm publish --access public`}</inlineCode>{`.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, navigate to the package directory.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run `}<inlineCode parentName="p">{`npm publish --access public`}</inlineCode>{`.`}</p>
      </li>
    </ol>
    <p>{`Public packages will say `}<inlineCode parentName="p">{`public`}</inlineCode>{` below the package name on the npm website.`}</p>
    <>{shared['organization-package-public'].image}</>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      